import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-ignore-maintenance-page',
    template: `
    <div class="wrapper">
      <p>
        Ignore maintenance is set to: <strong>{{ ignoreMaintenance }}</strong>
      </p>
      <p>
        You will automatically be redirected from this page in
        {{ timer }} seconds
      </p>
    </div>
  `,
    styles: [
        '.wrapper{background-color:white; padding:3rem;display:flex;flex-direction:column;align-items:center}',
    ],
})
export class IgnoreMaintenancePageComponent implements OnInit {
  public ignoreMaintenance: boolean;

  public timer: number = 5;

  constructor(public readonly router: Router) {
    this.ignoreMaintenance =
      Boolean(localStorage.getItem('ignore-maintenance'));

    if (this.ignoreMaintenance) {
      localStorage.removeItem('ignore-maintenance');
      this.ignoreMaintenance = false;
    } else {
      localStorage.setItem('ignore-maintenance', 'true');
      this.ignoreMaintenance = true;
    }
  }

  ngOnInit(): void {
    const interval = setInterval(() => {
      this.timer -= 1;

      if (this.timer === 0) {
        clearInterval(interval);
        void this.router.navigate(['/app']);
      }
    }, 1000);
  }
}
